import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { T } from "../../lib/testIds";

const links = [
  { to: "/services", label: "Services", tid: T.nav.services },
  { to: "/commercial", label: "Commercial", tid: T.nav.commercial },
  { to: "/faq", label: "FAQ", tid: T.nav.faq },
  { to: "/partner", label: "Partner", tid: T.nav.franchising, redirect: "/franchising" },
  { to: "/about", label: "About", tid: T.nav.about },
  { to: "/contact", label: "Contact", tid: T.nav.contact },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 h-16">
        <div data-testid={T.nav.logo}><Logo size="md" /></div>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.tid}
              className={({ isActive }) =>
                `text-sm font-subhead uppercase tracking-wider transition-colors ${isActive ? "text-[color:var(--ww-red)]" : "text-slate-700 hover:text-[color:var(--ww-navy)]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <NavLink to="/quote" data-testid={T.nav.quote} className="ww-btn-outline text-sm">Free Estimate</NavLink>
          <NavLink to="/book" data-testid={T.nav.book} className="ww-btn-primary text-sm">Book Now</NavLink>
        </div>
        <button
          className="md:hidden p-2 rounded-md text-[color:var(--ww-navy)]"
          data-testid={T.nav.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={l.tid} className="py-2 font-subhead uppercase tracking-wider text-slate-700">{l.label}</NavLink>
          ))}
          <NavLink to="/quote" onClick={() => setOpen(false)} className="ww-btn-outline text-sm text-center">Free Estimate</NavLink>
          <NavLink to="/book" onClick={() => setOpen(false)} className="ww-btn-primary text-sm text-center">Book Now</NavLink>
        </div>
      )}
    </header>
  );
}
